var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CallRPC',{on:{"click":_vm.handleWatch}}),_vm._l((_vm.random),function(arg,index){return _c('Argument',{key:index,attrs:{"argument":arg,"disabled":"","defaultValue":_vm.getDefaultValue(index)}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }